import { userdata } from "./table_typing"

export interface tableState {
    visible: boolean,
    condition: boolean,
    itemToDelete: string,
    model:{
        entry:userdata,
        link:userdata,
    },
    view:{
        loaded: boolean, 
        autorefresh: boolean,
    }
}

/**
 * Ausgangszustand des Brotkrumenpfads.
 *
 * Hier stand "Vodin / Side" — auf jeder Seite des Hub, unverändert. Zwei
 * Fehler auf einmal: Der Hub heißt Anima, nicht Vodin (so heißt der Spoke),
 * und "Side" ist ein Verschreiber ohne Bedeutung.
 *
 * Stehen bleiben konnte das, weil die Aktion `setCrumbs` zwar vorhanden ist,
 * aber von keiner Seite aufgerufen wird — der Ausgangszustand ist damit der
 * Dauerzustand. Solange das so ist, nennt der Pfad nur den Namen der
 * Anwendung; einen Unterpunkt zu erfinden, den niemand pflegt, wäre bloß die
 * nächste Unwahrheit. Die Ansicht blendet den zweiten Eintrag aus, solange er
 * leer ist.
 *
 * Dass die Seiten ihren Pfad selbst setzen, steht als eigener Punkt auf der
 * Liste.
 */
export const tableInitialState = {
    visible: false,
    condition: true,
    itemToDelete: "null",
    model:{
        entry:{
            main:"Anima",
            sub:"",
        },
        link:{
                main:"Anima",
                sub:"",
            },
        },
    view:{
        loaded: false,
        autorefresh: false,
    }
    }


export function deepCopyTableThingyState(toCopy:tableState):tableState{
    return {
        visible: false,
        condition: true,
        itemToDelete: "null",
        model:{
            entry:{
                main:toCopy.model.entry.main,
                sub:toCopy.model.entry.sub,
            },
            link:{
                main:toCopy.model.link.main,
                sub:toCopy.model.link.sub,
            },
        },
        view:{
            loaded:toCopy.view.loaded,
            autorefresh:toCopy.view.autorefresh
        }
    }
    
}